function SecondsToHHMMSS(s: number) {
    var h = Math.floor(s / 3600);
    s -= h * 3600;
    var m = Math.floor(s / 60);
    s -= m * 60;
    return h + " timer " + (m < 10 ? '0' + m : m) + " minutter " + (s < 10 ? '0' + s : s) + " sekunder.";
  }
export default SecondsToHHMMSS;